<template>
  <div id="slide_box" class="douwnload_complete">
    <div id="slide_content" :style="{background: siteCodeInfo[0].BACK_COLOR}">
      <div class="slide_block" id="douwnload_complete" :class="getShowClass()">
         <div class="slide_animate_block">
          <div class="bg" :style="{background: siteCodeInfo[0].BACK_COLOR}">
            <div class="wrap03 main_area">
              <div class="info_msg_box">
                <div>{{ downloadTarget + $msg.INFO.MSG_0001 }}</div>
                <div>{{ $msg.INFO.MSG_0002 }}</div>
              </div>
            </div>
          </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadCompleteDisp from '../../js/DownloadCompleteDisp'

export default {
  props: {
    siteCodeInfo: Array
  },
  data() {
    return {
      downloadTarget: ""
    }
  },
  created() {
    DownloadCompleteDisp.getDownloadTarget(this)
    DownloadCompleteDisp.activeHeaderLogo(this)
  },
}
</script>
